{
    "ChannelCode": "Kod",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Odkryj więcej funkcji",
                "ThanksMessage": "Dziękujemy, że byliście z nami,",
                "WorkingMessage": "mamy nadzieję, że tłumaczenie ulepszyło dla was to wydarzenie."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "Jak oceniacie jakość tłumaczenia?",
                "SessionClosedMessage": "Tłumaczenie na żywo zostało zakończone.",
                "ThankYouMessage": "Mamy nadzieję, że to pomogło!"
            }
        }
    },
    "Continue": "Kontynuuj",
    "Control": {
        "Original": "Oryginał",
        "Spacing": "Odstęp",
        "TextSize": "Rozmiar",
        "Tts": "TTS"
    },
    "Download": "Pobierz",
    "Idle": "Bezczynny",
    "Join": "Dołącz",
    "LanguageSettings": "Język",
    "Live": "W toku",
    "Loading": {
        "Entering": "Wchodzenie do kanału",
        "Joining": "Dołączanie do kanału"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Proszę wprowadzić kod kanału.",
            "InputPlaceholder": "Wpisz kod kanału",
            "Title": "Bądź obecny. Zrozum wszystko."
        },
        "SelectLanguage": {
            "SearchEmpty": "Brak pasującego języka",
            "SearchPlaceholder": "Szukaj języka",
            "Title": "Wybierz język tłumaczenia"
        }
    },
    "Pane": {
        "CatchUp": "Przejdź do najnowszych",
        "Source": "Oryginał",
        "Translation": "Tłumaczenie",
        "Tts": "Odczyt głosowy",
        "TtsShort": "TTS"
    },
    "Share": "Udostępnij",
    "SpeechSpeed": "Prędkość mowy",
    "Start": "Start",
    "Submit": "Wyślij",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "Ten kanał osiągnął limit połączeń."
            }
        },
        "Icon": {
            "ScrollToBottom": "Wróć do najnowszych",
            "ShareLink": "Udostępnij link",
            "SpeechRate": "Ustaw prędkość odtwarzania"
        }
    },
    "Toast": {
        "LanguageChanged": "Język tłumaczenia: {lang}",
        "LinkCopied": "Link skopiowany",
        "SourceOff": "Oryginał ukryty",
        "SourceOn": "Oryginał widoczny",
        "TtsOff": "Odczyt wyłączony",
        "TtsOn": "Odczyt włączony"
    },
    "Transcript": {
        "Start": "Początek transkrypcji"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Tekst Oryginalny",
            "summary": "Podsumowanie",
            "transcript": "Transkrypcje"
        },
        "translationLanguage": {
            "title": "Język tłumaczenia"
        }
    }
}
